import { createRef } from "react";

const scrollableDivRef = createRef<HTMLDivElement>();
export const useScrollRef = () => ({ scrollableDivRef });

export default useScrollRef;
